// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-selection-control {
  align-items: center;
  contain: layout;
  display: flex;
  flex: 1 0;
  grid-area: control;
  position: relative;
  user-select: none;
}
.v-selection-control .v-label {
  white-space: normal;
  word-break: break-word;
  height: 100%;
}
.v-selection-control--disabled {
  opacity: var(--v-disabled-opacity);
  pointer-events: none;
}
.v-selection-control--error .v-label, .v-selection-control--disabled .v-label {
  opacity: 1;
}
.v-selection-control--error:not(.v-selection-control--disabled) .v-label {
  color: rgb(var(--v-theme-error));
}
.v-selection-control--inline {
  display: inline-flex;
  flex: 0 0 auto;
  min-width: 0;
  max-width: 100%;
}
.v-selection-control--inline .v-label {
  width: auto;
}
.v-selection-control--density-default {
  --v-selection-control-size: 40px;
}

.v-selection-control--density-comfortable {
  --v-selection-control-size: 36px;
}

.v-selection-control--density-compact {
  --v-selection-control-size: 28px;
}

.v-selection-control__wrapper {
  width: var(--v-selection-control-size);
  height: var(--v-selection-control-size);
  display: inline-flex;
  align-items: center;
  position: relative;
  justify-content: center;
  flex: none;
}

.v-selection-control__input {
  width: var(--v-selection-control-size);
  height: var(--v-selection-control-size);
  align-items: center;
  display: flex;
  flex: none;
  justify-content: center;
  position: relative;
  border-radius: 50%;
}
.v-selection-control__input input {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.v-selection-control__input::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-color: currentColor;
  opacity: 0;
  pointer-events: none;
}
.v-selection-control__input:hover::before {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
.v-selection-control__input > .v-icon {
  opacity: var(--v-medium-emphasis-opacity);
}
.v-selection-control--disabled .v-selection-control__input > .v-icon, .v-selection-control--dirty .v-selection-control__input > .v-icon, .v-selection-control--error .v-selection-control__input > .v-icon {
  opacity: 1;
}
.v-selection-control--error:not(.v-selection-control--disabled) .v-selection-control__input > .v-icon {
  color: rgb(var(--v-theme-error));
}
.v-selection-control--focus-visible .v-selection-control__input::before {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VSelectionControl/VSelectionControl.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yEAAyE;AAC3E","sourcesContent":[".v-selection-control {\n  align-items: center;\n  contain: layout;\n  display: flex;\n  flex: 1 0;\n  grid-area: control;\n  position: relative;\n  user-select: none;\n}\n.v-selection-control .v-label {\n  white-space: normal;\n  word-break: break-word;\n  height: 100%;\n}\n.v-selection-control--disabled {\n  opacity: var(--v-disabled-opacity);\n  pointer-events: none;\n}\n.v-selection-control--error .v-label, .v-selection-control--disabled .v-label {\n  opacity: 1;\n}\n.v-selection-control--error:not(.v-selection-control--disabled) .v-label {\n  color: rgb(var(--v-theme-error));\n}\n.v-selection-control--inline {\n  display: inline-flex;\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: 100%;\n}\n.v-selection-control--inline .v-label {\n  width: auto;\n}\n.v-selection-control--density-default {\n  --v-selection-control-size: 40px;\n}\n\n.v-selection-control--density-comfortable {\n  --v-selection-control-size: 36px;\n}\n\n.v-selection-control--density-compact {\n  --v-selection-control-size: 28px;\n}\n\n.v-selection-control__wrapper {\n  width: var(--v-selection-control-size);\n  height: var(--v-selection-control-size);\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  justify-content: center;\n  flex: none;\n}\n\n.v-selection-control__input {\n  width: var(--v-selection-control-size);\n  height: var(--v-selection-control-size);\n  align-items: center;\n  display: flex;\n  flex: none;\n  justify-content: center;\n  position: relative;\n  border-radius: 50%;\n}\n.v-selection-control__input input {\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.v-selection-control__input::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  background-color: currentColor;\n  opacity: 0;\n  pointer-events: none;\n}\n.v-selection-control__input:hover::before {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-selection-control__input > .v-icon {\n  opacity: var(--v-medium-emphasis-opacity);\n}\n.v-selection-control--disabled .v-selection-control__input > .v-icon, .v-selection-control--dirty .v-selection-control__input > .v-icon, .v-selection-control--error .v-selection-control__input > .v-icon {\n  opacity: 1;\n}\n.v-selection-control--error:not(.v-selection-control--disabled) .v-selection-control__input > .v-icon {\n  color: rgb(var(--v-theme-error));\n}\n.v-selection-control--focus-visible .v-selection-control__input::before {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
